import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Row, Table, Spin } from "antd"; // Spin is used for loader
import "react-datepicker/dist/react-datepicker.css";
import LeaveFilter from "../../../components/LeaveFilter";
import axios from "axios";


const AdminLeave = ({
  currentPage,
  pageSize,
  totalRecord,
  totalPage,
  setCurrentPage,
  setPageSize,
}) => {
  const [fieldInputs, setFieldInputs] = useState(true);
  const [reqState, setReqState] = useState();
  const [isFullScreen, setFullScreen] = useState(false);
  const [loading, setLoading] = useState(false);  // Added loading state
  const maximizeBtnRef = useRef(null);

  const [billMonth, setBillMonth] = useState(["7"]);
  const [consumer, setConsumer] = useState(["DS"]);
  const [bucket, setBucket] = useState([[0, 1]]);
  const [lrValue, setLrValue] = useState([0, 100]);
  const [sanctionedValue, setSanctionedValue] = useState([0, 15346]);
  const [netBill, setNetBill] = useState([5000, 58613555]);
  const [consumerList, setConsumerList] = useState([]);
  const [consumerListLen, setConsumerListLen] = useState(0);

  const tableData = [];

  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        setFullScreen(true);
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          setFullScreen(false);
        }
      }
    };

    const cleanup = () => {
      if (isFullScreen && document.exitFullscreen) {
        document.exitFullscreen();
        setFullScreen(false);
      }
    };

    const maximizeBtn = maximizeBtnRef.current;
    maximizeBtn.addEventListener("click", handleClick);

    return () => {
      maximizeBtn.removeEventListener("click", handleClick);
      cleanup();
    };
  }, [isFullScreen]);

  const getData = async () => {
    setLoading(true); // Show loader when starting data fetch
    const consumer_list_url = "https://tripura.saielectricity.com/payment_predection/Handler/get_consumer_list_handler.php";

    const consumer_list_data = {
      "BillMonth": billMonth,
      "CONSUMER_CATEGORY": consumer,
      "SANCTIONED_LOAD_MIN": sanctionedValue[0],
      "SANCTIONED_LOAD_MAX": sanctionedValue[1],
      "Prediction_Bucket_MIN": bucket[0][0],
      "Prediction_Bucket_MAX": bucket[0][1],
      "NET_BILL_MIN": netBill[0],
      "NET_BILL_MAX": netBill[1],
    };

    try {
      console.log('json data to post', consumer_list_data);
      const response = await axios.post(consumer_list_url, consumer_list_data);
      console.log('response of consumer list', response.data.data);
      setConsumerList(response.data.data);
      setConsumerListLen(response.data.data.length);
    } catch (error) {
      setConsumerList([]);
      setConsumerListLen(0);
      console.log('error in data posting to get consumer list');
    } finally {
      setLoading(false); // Hide loader once data is fetched
    }
  };

  useEffect(() => {
    getData();
  }, [billMonth, consumer, bucket, sanctionedValue, netBill]); // Trigger data fetch on filter change

  const columns = [
    {
      title: "Account Id",
      dataIndex: "AC_ID",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.AC_ID.length - b.AC_ID.length,
    },
    {
      title: "Name",
      dataIndex: "NAME",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.NAME.length - b.NAME.length,
    },
    {
      title: "Address",
      dataIndex: "ADDRESS",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.ADDRESS.length - b.ADDRESS.length,
    },
    {
      title: "Net Bill",
      dataIndex: "NET_BILL",
      render: (text) => <span>{Number(text).toFixed(2)}</span>,
      sorter: (a, b) => a.NET_BILL.length - b.NET_BILL.length,
    },
  ];

  return (
    <>
      <ToastContainer />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h3 className="page-title">Call To Action</h3>
              </div>
              <div className="col-md-8 float-end ms-auto">
                <div className="d-flex title-head">
                  <div className="view-icons">
                    <Link
                      to="#"
                      className="list-view btn btn-link"
                      id="collapse-header"
                      ref={maximizeBtnRef}
                    >
                      <i className="las la-expand-arrows-alt" />
                    </Link>
                    <Link
                      to="#"
                      id="filter_search"
                      onClick={() => setFieldInputs(!fieldInputs)}
                      className={
                        fieldInputs
                          ? "list-view btn btn-link active-filter"
                          : "list-view btn btn-link"
                      }
                    >
                      <i className="las la-filter" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          <div
            className="filter-filelds"
            id="filter_inputs"
            style={{ display: fieldInputs ? "block" : "none" }}
          >
            <LeaveFilter
              setSanctionedValue={setSanctionedValue}
              setNetBill={setNetBill}
              setLrValue={setLrValue}
              setBillMonth={setBillMonth}
              setConsumer={setConsumer}
              setBucket={setBucket}
              consumerList={consumerList}
              consumerListLen={consumerListLen}
            />
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center">
                    <Spin size="large" /> {/* Loader shown while data is loading */}
                  </div>
                ) : (
                  <Table
                    rowKey={(record) => record.id}
                    scroll={{ y: 300 }}
                    columns={columns}
                    dataSource={consumerList?.length > 0 ? consumerList : []}
                    className="table-striped"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLeave;
